<template>
  <div style="width: 100%">
    <empty-alert :icon="'exclamation-circle'" :color="'orange accent-4'">
      <div slot="content">
        <p>
          <strong>Preencha seu questionário de avaliação inicial</strong>
        </p>
      </div>
      <div slot="actions">
        <v-btn round depressed large color="success" dark
          v-modal-trigger="'showNewHealthCard'">
          Iniciar
        </v-btn>
      </div>
    </empty-alert>
    <new-health-card></new-health-card>
  </div>
</template>

<script>
import EmptyAlert from '@/modules/EmptyAlert'
import UserNewHealthCard from '@/components/user/evaluations/UserNewHealthCard'

export default {
  props: ['user'],
  components: {
    'empty-alert': EmptyAlert,
    'new-health-card': UserNewHealthCard
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/evaluations/UserHealthCardNotify.vue